import { render, staticRenderFns } from "./ReviewsSlider.vue?vue&type=template&id=67940239&scoped=true&"
import script from "./ReviewsSlider.vue?vue&type=script&lang=js&"
export * from "./ReviewsSlider.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsSlider.vue?vue&type=style&index=0&id=67940239&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67940239",
  null
  
)

export default component.exports